document.addEventListener("DOMContentLoaded", function () {
  const shadeOptions = document.querySelectorAll(".shade-option");

  // Make all options selected by default
  shadeOptions.forEach(option => option.classList.add("selected"));

  // Optional: toggle selection on click
  shadeOptions.forEach(option => {
    option.addEventListener("click", function () {
      this.classList.toggle("selected");
    });
  });
});
